import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AllPlansInclude() {
  const included = ['Diseño profesional', 'Adaptación a dispositivos móviles', 'Dominio por 1 año', 'Hosting por 1 año', 'Certificado SSL gratis incluido', 'Publicación del sitio', 'Redacción de textos', 'Logotipo básico', 'Branding básico', 'SEO básico', 'Correo corporativo según el plan', 'Soporte inicial'];
  const notIncluded = ['Correo corporativo profesional', 'Branding avanzado', 'Cambios ilimitados post-entrega', 'SEO mensual continuo', 'Campañas publicitarias en redes sociales', 'Integraciones avanzadas con terceros', 'Carga masiva de mas de 20 productos', 'Soporte y mantenimiento mensual', 'Gestion de redes sociales', 'Publicidad pagada en Google o Meta', 'Actualizaciones de contenido post-entrega', 'Traduccion del sitio a otro idioma', 'Dominio y hosting desde el segundo año'];
  return <section className="py-32 bg-nova-bg" data-id="element-53">
      <div className="max-w-4xl mx-auto px-6" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-nova-card rounded-2xl p-8 md:p-12 border border-nova-bg-alt shadow-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_0_20px_rgba(0,212,255,0.15)]" data-id="element-55">
          <h2 className="text-3xl font-bold text-center text-nova-text" data-id="element-56">
            Todos Nuestros Planes Incluyen
          </h2>
          <div className="w-16 h-[3px] bg-nova-accent mx-auto mt-4 mb-10" data-id="element-57" />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-58">
            {included.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-59">
                <CheckCircle2 className="text-green-500 shrink-0 mt-1" size={20} data-id="element-60" />
                <span className="text-nova-text-muted" data-id="element-61">{item}</span>
              </div>)}
          </div>

          <div className="border-t border-nova-bg-alt pt-10" data-id="element-62">
            <h3 className="text-xl font-semibold text-nova-text mb-2" data-id="element-63">
              NOTA IMPORTANTE:
            </h3>
            <p className="text-nova-text-muted mb-6" data-id="element-64">
              Algunos servicios adicionales pueden cotizarse por separado según
              la complejidad del proyecto.
            </p>

            <h4 className="text-lg font-medium text-red-400 mb-4" data-id="element-65">
              NO INCLUYE salvo acuerdo adicional:
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-66">
              {notIncluded.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-67">
                  <XCircle className="text-red-500/70 shrink-0 mt-1" size={18} data-id="element-68" />
                  <span className="text-nova-text-muted text-sm" data-id="element-69">{item}</span>
                </div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}